import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from '../lib/cn';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

const baseClasses =
    'flex w-full rounded-md border border-solid border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:placeholder:text-gray-500';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, rows = 3, ...props }, ref) => (
        <textarea ref={ref} rows={rows} className={cn(baseClasses, className)} {...props} />
    ),
);
Textarea.displayName = 'Textarea';
